/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  GetToolUsageSummaryPayload,
  GetToolUsageSummaryPayload$Outbound,
  GetToolUsageSummaryPayload$outboundSchema,
} from "../components/gettoolusagesummarypayload.js";

export type GetToolUsageTargetToolBreakdownSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetToolUsageTargetToolBreakdownSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type GetToolUsageTargetToolBreakdownSecurity = {
  option1?: GetToolUsageTargetToolBreakdownSecurityOption1 | undefined;
  option2?: GetToolUsageTargetToolBreakdownSecurityOption2 | undefined;
};

export type GetToolUsageTargetToolBreakdownRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  getToolUsageSummaryPayload: GetToolUsageSummaryPayload;
};

/** @internal */
export type GetToolUsageTargetToolBreakdownSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetToolUsageTargetToolBreakdownSecurityOption1$outboundSchema:
  z.ZodMiniType<
    GetToolUsageTargetToolBreakdownSecurityOption1$Outbound,
    GetToolUsageTargetToolBreakdownSecurityOption1
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function getToolUsageTargetToolBreakdownSecurityOption1ToJSON(
  getToolUsageTargetToolBreakdownSecurityOption1:
    GetToolUsageTargetToolBreakdownSecurityOption1,
): string {
  return JSON.stringify(
    GetToolUsageTargetToolBreakdownSecurityOption1$outboundSchema.parse(
      getToolUsageTargetToolBreakdownSecurityOption1,
    ),
  );
}

/** @internal */
export type GetToolUsageTargetToolBreakdownSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const GetToolUsageTargetToolBreakdownSecurityOption2$outboundSchema:
  z.ZodMiniType<
    GetToolUsageTargetToolBreakdownSecurityOption2$Outbound,
    GetToolUsageTargetToolBreakdownSecurityOption2
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function getToolUsageTargetToolBreakdownSecurityOption2ToJSON(
  getToolUsageTargetToolBreakdownSecurityOption2:
    GetToolUsageTargetToolBreakdownSecurityOption2,
): string {
  return JSON.stringify(
    GetToolUsageTargetToolBreakdownSecurityOption2$outboundSchema.parse(
      getToolUsageTargetToolBreakdownSecurityOption2,
    ),
  );
}

/** @internal */
export type GetToolUsageTargetToolBreakdownSecurity$Outbound = {
  Option1?: GetToolUsageTargetToolBreakdownSecurityOption1$Outbound | undefined;
  Option2?: GetToolUsageTargetToolBreakdownSecurityOption2$Outbound | undefined;
};

/** @internal */
export const GetToolUsageTargetToolBreakdownSecurity$outboundSchema:
  z.ZodMiniType<
    GetToolUsageTargetToolBreakdownSecurity$Outbound,
    GetToolUsageTargetToolBreakdownSecurity
  > = z.pipe(
    z.object({
      option1: z.optional(z.lazy(() =>
        GetToolUsageTargetToolBreakdownSecurityOption1$outboundSchema
      )),
      option2: z.optional(z.lazy(() =>
        GetToolUsageTargetToolBreakdownSecurityOption2$outboundSchema
      )),
    }),
    z.transform((v) => {
      return remap$(v, {
        option1: "Option1",
        option2: "Option2",
      });
    }),
  );

export function getToolUsageTargetToolBreakdownSecurityToJSON(
  getToolUsageTargetToolBreakdownSecurity:
    GetToolUsageTargetToolBreakdownSecurity,
): string {
  return JSON.stringify(
    GetToolUsageTargetToolBreakdownSecurity$outboundSchema.parse(
      getToolUsageTargetToolBreakdownSecurity,
    ),
  );
}

/** @internal */
export type GetToolUsageTargetToolBreakdownRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  GetToolUsageSummaryPayload: GetToolUsageSummaryPayload$Outbound;
};

/** @internal */
export const GetToolUsageTargetToolBreakdownRequest$outboundSchema:
  z.ZodMiniType<
    GetToolUsageTargetToolBreakdownRequest$Outbound,
    GetToolUsageTargetToolBreakdownRequest
  > = z.pipe(
    z.object({
      gramKey: z.optional(z.string()),
      gramSession: z.optional(z.string()),
      gramProject: z.optional(z.string()),
      getToolUsageSummaryPayload: GetToolUsageSummaryPayload$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramKey: "Gram-Key",
        gramSession: "Gram-Session",
        gramProject: "Gram-Project",
        getToolUsageSummaryPayload: "GetToolUsageSummaryPayload",
      });
    }),
  );

export function getToolUsageTargetToolBreakdownRequestToJSON(
  getToolUsageTargetToolBreakdownRequest:
    GetToolUsageTargetToolBreakdownRequest,
): string {
  return JSON.stringify(
    GetToolUsageTargetToolBreakdownRequest$outboundSchema.parse(
      getToolUsageTargetToolBreakdownRequest,
    ),
  );
}
